var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(require(("@/components/connectors/" + _vm.fileName + ".svg")),{tag:"component",class:{ reversed: _vm.reversed }})}
var staticRenderFns = []

export { render, staticRenderFns }